// extracted by mini-css-extract-plugin
export default {"menuBlock":"jE-z","title":"kE-z","nav":"lE-z","flexCell":"mE-z","facetLink":"nE-z"};